// extracted by mini-css-extract-plugin
export default {"actions":"StudioName_actions__k18Q6"};